import React from 'react'

import { Form, Col } from '_zari/core'

const CuentaContableFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Col>
        <Form.Checkbox id='checkbox-verificar' name='checkbox-verificar' label='Verificar Cuenta' onChange={onChange} checked={value} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableFormGroup)
